export const DATA_ANALYSIS_USER_ID_KEY = 'dataAnalysisUserId';
